import React from "react";
import PropTypes from "prop-types";
import {
  capitalizeFirstLetter,
  handleStatusStyle,
} from "../../../../../../common/helper";
import "./status-info-header.css"

const StatusInfoHeader = (props) => {
  const { trade } = props;
  

  const handleTradeStatus = (trade) => {
    switch (trade.status) {
      case 'CREATED':
        return (
        <span
          className={`createdTrade statusColumn `}
        >
          Created
        </span>
      )
      case 'BOOKED':
        return (
        <span
          className={`createdTrade statusColumn `}
        >
          Booked
        </span>
      )
      case 'COMPLETED':
        return (
        <span
          className={`completedTrade statusColumn `}
        >
          Completed
        </span>
      )
      case 'CANCELLED':
        return (
        <span
          className={`cancelledTrade statusColumn `}
        >
          Cancelled
        </span>
      )
      case 'AWAITING_DOCUMENTS':
        return (
        <span
          className={`awaitingDocuments statusColumn `}
        >
          Awaiting Documents
        </span>
      )
      case 'AWAITING_AUTHORISATION':
        return (
        <span
          className={`awaitingAuthorisation statusColumn `}
        >
          Awaiting Authorisation
        </span>
      )
      case 'SUBMITTED_TO_BANK':
        return (
        <span
          className={`submittedToBank statusColumn `}
        >
          Submitted to Bank
        </span>
      )
      default:
        return (
        <span
          className={`createdTrade statusColumn `}
        >
          Unknown
        </span>
      )
    }
  };

  return (
    <>
      <div className="row seperator">
        <div className="col-7">
          <label className="formlabel">
            Status
            {handleTradeStatus(trade)}
          </label>
        </div>
        <div className="col-5 flexCol">
          <label className="formlabel">Information</label>
          <p className="description">All in order</p>
        </div>
      </div>
    </>
  );
};

StatusInfoHeader.propTypes = {
  trade: PropTypes.object.isRequired,
};

export default StatusInfoHeader;
